import Logger from '../utils/logger';
import _ from '../utils/underscore';

export interface IBaseObject {
    getClassName(): string;
}

/**
 *
 *
 * @description - BaseObject is the ancestor of all cgp entity, every one inherit from him
 * append on each entity global behavior such as logger or define if it's singleton or not.
 *
 */
export default class BaseObject {
    static create(params?: any): any {
        const $instance = new this(); // constructor SHOULD NOT GET ANYTHING... it's TEMPORARY HERE!

        if (_.isFunction($instance.init)) {
            $instance.init.apply($instance, arguments);
        }

        return $instance;
    }

    constructor() {
        this._createLogger();
    }


    protected init(params: any): void {
    }

	protected logger: Logger;

    private _createLogger(): void {
        this.logger = new Logger(this.getClassName());
    }


    /**
     * This si a helper method for throwing an exception in a consistent and standard way
     * @param lineNumber - it must always take this value '43'
     * @param message - the error message
     * @param context - This parameter is optional and it can be used to
     *                  provide more information about the exception.
     */
    protected throwError(lineNumber: string, message: string, context?: any): void {
        const theError = {
            message: message,
            className: this.getClassName(),
            lineNumber: lineNumber,
            context: context,
            stackTrace: new Error().stack,
        };

        this.logger.error(theError);
        throw new Error(JSON.stringify(theError));
    }

    protected throwArgumentExpected(lineNumber: string, methodName: string, argumentName: string, context?: any): void {
        this.throwError(lineNumber, `${this.getClassName()}.${methodName} method expects parameter ${argumentName} which was not provided`, context);
    }

    protected reThrowError(lineNumber: string, message: string, innerError: any, context?: any): void {

        this.logger.error({
            message: message,
            className: this.getClassName(),
            lineNumber: lineNumber,
            context: context,
            stackTrace: new Error().stack,
            innerError: innerError,
        });

        throw innerError;

    }

    protected throwNotImplemented(lineNumber: string, methodName: string): void {
        this.throwError(lineNumber, `${this.getClassName()} doesn't implement ${methodName} method`);
    }

    getClassName(): string {

        const thisProto = Object.getPrototypeOf(this);

        if(thisProto.constructor.CLASS) {
            return thisProto.constructor.CLASS;
        } else {
            return thisProto.constructor.name;
        }


    }
}
